import {Component, OnDestroy, OnInit} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {HttpParams} from '@angular/common/http';
import * as _ from 'lodash';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {Subscription} from "rxjs";

@Component({
  selector: 'app-billing-list',
  templateUrl: './billing-list.component.html',
  styleUrls: ['./billing-list.component.scss']
})
export class BillingListComponent implements OnInit, OnDestroy {
  itemsPerPage = 10;

  monthListDropdown = [];
  yearList: any[] = [];
  list: any = [];
  selectedMonth: any;
  selectedYear: any;
  totalItems: number;
  currentPage = 1;
  loading = false;
  title = '';
  selectedDuplictedData = false;
  includeInB2POnly = false;
  loading_excel_report = false;
  subs: Subscription;

  constructor(private apiService: ApiService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.loadTexts();
    this.populateDropdown();
    this.loadData();
    this.subs = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadTexts();
    });
  }

  loadTexts() {
    this.monthListDropdown = [];
    this.translate.get('COMMON.ALL').subscribe(() => {
      this.monthListDropdown.push(
        {label: this.translate.instant('MONTH.JANUARY'), value: 1},
        {label: this.translate.instant('MONTH.FEBRUARY'), value: 2},
        {label: this.translate.instant('MONTH.MARCH'), value: 3},
        {label: this.translate.instant('MONTH.APRIL'), value: 4},
        {label: this.translate.instant('MONTH.MAY'), value: 5},
        {label: this.translate.instant('MONTH.JUNE'), value: 6},
        {label: this.translate.instant('MONTH.JULY'), value: 7},
        {label: this.translate.instant('MONTH.AUGUST'), value: 8},
        {label: this.translate.instant('MONTH.SEPTEMBER'), value: 9},
        {label: this.translate.instant('MONTH.OCTOBER'), value: 10},
        {label: this.translate.instant('MONTH.NOVEMBER'), value: 11},
        {label: this.translate.instant('MONTH.DECEMBER'), value: 12}
      );
    });
  }

  populateDropdown() {
    const currentDate = new Date();
    // populate year list back within 10 years
    const thisYear = currentDate.getFullYear();
    for (let i = 0; i <= 10; i++) {
      this.yearList.push({label: (thisYear - i).toString(), value: thisYear - i});
    }

    // set current month and year
    this.selectedMonth = currentDate.getMonth() + 1;
    this.selectedYear = thisYear;
  }

  // search() {
  //   if (this.currentPage != 1) {
  //     this.currentPage = 1;
  //     this.pageChanged();
  //   }
  //   else {
  //     this.pageChanged();
  //   }
  // }

  pageChanged() {
    const params = new HttpParams().set('page', _.toString(this.currentPage));
    this.loadData(params);
  }

  search() {
    this.currentPage = 1;
    this.loadData();
  }

  loadData(params?) {
    const data = {
      month: this.selectedMonth,
      year: this.selectedYear,
      duplicate_only: this.selectedDuplictedData,
      included_in_b2p_only: this.includeInB2POnly
    };

    this.title = '';
    this.loading = true;
    this.apiService.sign_counter(data, params).subscribe(
      (res: any) => {
        this.list = res.results;
        this.totalItems = res.count;
        // this.title = "พบการลงลายมือชื่อดิจิทัลทั้งหมด " + this.totalItems.toLocaleString() + " ครั้ง";
        this.loading = false;
      }
    );
  }

  clearSearch() {
    const currentDate = new Date();

    // set current month and year
    this.selectedMonth = currentDate.getMonth() + 1;
    this.selectedYear = currentDate.getFullYear();
    this.selectedDuplictedData = false;

    this.search();
  }

  humanFileSize(size) {
    const i = Math.floor(Math.log(size) / Math.log(1024));
    return (size / Math.pow(1024, i)).toFixed(0) + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i];
  }

  DownloadExcelReport() {
    this.loading_excel_report = true;

    const params = {
      month: this.selectedMonth,
      year: this.selectedYear,
      duplicate_only: this.selectedDuplictedData,
      included_in_b2p_only: this.includeInB2POnly
    };
    this.apiService.getBillingExcelReport(params).subscribe(
      (obj) => {
        const filename = 'billing_report_' + this.selectedMonth + '_' + this.selectedYear + '.csv';
        this.apiService.createDownloadFile(obj, filename);
        this.loading_excel_report = false;
        this.sniff('DOWNLOAD_XLS', filename);
      },
      error => {
        this.loading_excel_report = false;
      }
    );
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'BILLING',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}




// WEBPACK FOOTER //
// /opt/app/src/app/features/billing/billing-list/billing-list.component.ts